import { Tooltip } from "antd";
import { ColumnType } from "antd/lib/table";
import { formatarDataSemTimezone, getMotivo, limitarCaracteres } from "../utils";
import { MdOutlineAddCircle, MdFastForward, MdFastRewind, MdCancel, MdInfo, MdOutlineSwapHoriz, MdCheck } from "react-icons/md";
import { TimeLineIcon, Type, IconInfo } from "../styles";

const columns = (): ColumnType<any>[] => {
  let columnsShow: ColumnType<any>[] = [
    {
      title: "Timeline",
      dataIndex: "tipoAlteracao",
      align: "center",
      width: 20,
      render: (status: string) => {
        return (
          <span style={{ fontSize: 13 }}>
            {
              status.toLocaleLowerCase() === "antecipado" ? (
                <TimeLineIcon color="#3498db"><MdFastRewind /></TimeLineIcon>
              ) : status.toLocaleLowerCase() === "prorrogado" || status.toLocaleLowerCase() === "reaberto" ? (
                <TimeLineIcon color="#f39c12">{status.toLocaleLowerCase() === "reaberto" ? <MdOutlineSwapHoriz /> : <MdFastForward />}</TimeLineIcon>
              ) : status.toLocaleLowerCase() === "cancelado" ? (
                <TimeLineIcon color="#e74c3c"><MdCancel /></TimeLineIcon>
              ) : <TimeLineIcon color="#27ae60">{status.toLocaleLowerCase() === "encerrado" ? <MdCheck /> : <MdOutlineAddCircle />}</TimeLineIcon>
            }

          </span>
        )
      },
    },
    {
      title: "Data e Hora",
      dataIndex: "dataCriacao",
      align: "center",
      width: 35,
      render: (_, dataValue: any) => {
        const newDate = dataValue.status === "Cancelada" ? dataValue.reagendamentoDataAtualizacao : dataValue.dataCriacao
        return (
          <span style={{ fontSize: 13 }}>{formatarDataSemTimezone(newDate) ?? "-"}</span>
        )
      },
    },
    {
      title: "Operação",
      dataIndex: "operacao",
      align: "center",
      width: 50,
      render: (value: string) => <span title={value} style={{ fontSize: 13 }}>{limitarCaracteres(value, 25) ?? "-"}</span>,
    },
    {
      title: "Tipo de Alteração",
      dataIndex: "tipoAlteracao",
      align: "center",
      width: 40,
      render: (status: string) => {
        return (
          <span style={{ fontSize: 13 }}>
            {
              status.toLocaleLowerCase() === "antecipado" ? (
                <Type color="#3498db">{status}</Type>
              ) : status.toLocaleLowerCase() === "prorrogado" || status.toLocaleLowerCase() === "reaberto" ? (
                <Type color="#f39c12">{status}</Type>
              ) : status.toLocaleLowerCase() === "cancelado" ? (
                <Type color="#e74c3c">{status}</Type>
              ) : <Type color="#27ae60">{status}</Type>
            }
          </span>
        )
      },
    },
    {
      title: "Quantidade de Dias",
      dataIndex: "reagendamentoQuantidadeDias",
      align: "center",
      width: 40,
      render: (value: number) => <span style={{ fontSize: 13, fontWeight: 500 }}>{value ?? "-"}</span>,
    },
    {
      title: "Data Inicial",
      dataIndex: "dataAnterior",
      align: "center",
      width: 30,
      render: (value: string) => <span style={{ fontSize: 13 }}>{formatarDataSemTimezone(value) ?? "-"}</span>,
    },
    {
      title: "Nova Data",
      dataIndex: "dataProgramada",
      align: "center",
      width: 30,
      render: (_: any, dataValue: any) => {
        let data = formatarDataSemTimezone(dataValue?.dataProgramada, false, true);

        if (dataValue?.periodoDataInicio && dataValue?.periodoDataFim) {
          data = `${formatarDataSemTimezone(dataValue?.periodoDataInicio, false, true)} à ${formatarDataSemTimezone(dataValue?.periodoDataFim, false, true)}`;
        }
        return (
          <span style={{ color: "#2d3436" }}>
            {data}
          </span>
        )
      },
    },
    {
      title: "Usuário Responsável",
      dataIndex: "usuarioCriacao",
      align: "center",
      width: 50,
      render: (_, dataValue: any) => {
        const user = dataValue.status === "Cancelada" ? dataValue.usuarioReagendamento : dataValue.usuario
        return (
          <span style={{ fontSize: 13 }}>{user ?? "-"}</span>
        )
      },
    },
    {
      title: "Justificativa",
      dataIndex: "reagendamentoMotivo",
      align: "center",
      width: 50,
      render: (value: string, dataValue: any) => {
        return (
          <span style={{ fontSize: 13 }}>{value || getMotivo(value) || getMotivo(dataValue.motivo) || "-"}</span>
        )
      },
    },
    {
      title: "Observação",
      dataIndex: "reagendamentoObservacao",
      align: "center",
      width: 30,
      render: (value: string, dataValue: any) =>
        <Tooltip title={value || dataValue.observacao || "-"}>
          <IconInfo>
            <MdInfo />
          </IconInfo>
        </Tooltip>
    },
  ];

  return columnsShow;
}

export default columns;
